import styled from 'styled-components';

const Col = styled.div`
  margin-top: 1em;
  margin-bottom: 1em;
`;

export default Col;
